module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-gray"
  }, [_c('div', {
    staticClass: "form-content"
  }, [_c('div', {
    staticClass: "order-success"
  }, [_c('div', {
    staticClass: "icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("报名成功")]), _vm._v(" "), (_vm.row.erweiimg.length > 0) ? _c('img', {
    attrs: {
      "src": _vm.row.erweiimg[0].url
    }
  }) : _vm._e(), _vm._v(" "), (_vm.row.erweiimg.length > 0) ? _c('p', [_vm._v("有关赛事信息将统一在赛事微信群公布，请各参赛队伍联系人或教练员主动加入并留意查看")]) : _vm._e()]), _vm._v(" "), _c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "label-width": "100px"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "单位",
      "prop": "name"
    }
  }, [_vm._v(_vm._s(_vm.row.danwei))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "队伍",
      "prop": "name"
    }
  }, [_vm._v(_vm._s(_vm.row.mingcheng))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "赛区",
      "prop": "name"
    }
  }, [_vm._v(_vm._s(_vm.row.saiqu_name))])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [(_vm.row.need_video == 1) ? _c('el-button', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'ISaiApplyVideoList',
        query: {
          id: _vm.row.id
        }
      }),
      expression: "{name:'ISaiApplyVideoList',query:{id:row.id}}"
    }],
    attrs: {
      "round": ""
    }
  }, [_vm._v(_vm._s(_vm.row.video_ok ? '视频已上传' : '上传视频') + "\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('el-divider', [_vm._v("秩序册信息")]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "赛季",
      "prop": "name"
    }
  }, [_vm._v(_vm._s(_vm.pageData.sjname))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "赛区",
      "prop": "name"
    }
  }, [_vm._v(_vm._s(_vm.pageData.sqname))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "单位",
      "prop": "name"
    }
  }, [_vm._v(_vm._s(_vm.pageData.danwei))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "队伍名称",
      "prop": "name"
    }
  }, [_vm._v(_vm._s(_vm.pageData.mingcheng))])], 1), _vm._v(" "), (_vm.pageData.heying) ? _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "队伍照片",
      "prop": "name"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.pageData.heying,
      "target": "_blank"
    }
  }, [_c('img', {
    staticStyle: {
      "max-height": "100px"
    },
    attrs: {
      "src": _vm.pageData.heying
    }
  })])])], 1) : _vm._e()], 1), _vm._v(" "), _c('el-divider', [_vm._v("人员信息")]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_vm._l((_vm.pageData.lingdui_list), function(user, index) {
    return _c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "领队"
      }
    }, [_c('el-tag', {
      key: index,
      attrs: {
        "type": "primary"
      }
    }, [_vm._v(" " + _vm._s(user.name) + " " + _vm._s(user.num) + "\n            ")])], 1)], 1)
  }), _vm._v(" "), _vm._l((_vm.pageData.jiaolianyuan_list), function(user, index) {
    return _c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": '教练员' + (index + 1)
      }
    }, [_c('el-tag', {
      key: index,
      attrs: {
        "type": "primary"
      }
    }, [_vm._v(" " + _vm._s(user.name) + " " + _vm._s(user.num) + "\n            ")])], 1)], 1)
  }), _vm._v(" "), _vm._l((_vm.pageData.caipanyuan_list), function(user, index) {
    return _c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": '裁判员' + (index + 1)
      }
    }, [_c('el-tag', {
      key: index,
      attrs: {
        "type": "primary"
      }
    }, [_vm._v(" " + _vm._s(user.name) + " " + _vm._s(user.num) + "\n            ")])], 1)], 1)
  }), _vm._v(" "), _vm._l((_vm.pageData.yundongyuan_list), function(user, index) {
    return _c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": '运动员' + (index + 1)
      }
    }, [_c('el-tag', {
      key: index,
      attrs: {
        "type": "primary"
      }
    }, [_vm._v(" " + _vm._s(user.name) + " " + _vm._s(user.num) + "\n                ")])], 1)], 1)
  })], 2), _vm._v(" "), _c('el-divider', [_vm._v("参赛人数")]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "领队",
      "prop": "name"
    }
  }, [_vm._v("1")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "教练员",
      "prop": "name"
    }
  }, [_vm._v(_vm._s(_vm.pageData.jiaolianyuan_list.length))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "裁判员",
      "prop": "name"
    }
  }, [_vm._v(_vm._s(_vm.pageData.caipanyuan_list.length))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "运动员",
      "prop": "name"
    }
  }, [_vm._v(_vm._s(_vm.pageData.yundongyuan_list.length))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "总计",
      "prop": "name"
    }
  }, [_vm._v(_vm._s(_vm.pageData.member_total_count))])], 1)], 1), _vm._v(" "), _vm._l((_vm.pageData.subject), function(subject, index) {
    return _c('div', [_c('el-divider', [_vm._v("项目信息" + _vm._s(index + 1))]), _vm._v(" "), _c('el-row', {
      attrs: {
        "gutter": 20
      }
    }, [_c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "项目",
        "prop": "name"
      }
    }, [_vm._v(_vm._s(subject.subject_name))])], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 12
      }
    }, _vm._l((subject.jiaolian), function(yundongyuan, index) {
      return _c('el-form-item', {
        attrs: {
          "label": "教练员",
          "prop": "jiaolian"
        }
      }, [_vm._v("\n              教练员" + _vm._s(index + 1) + "\n              "), _c('el-tag', {
        key: index,
        staticStyle: {
          "margin-right": "10px"
        },
        attrs: {
          "type": "primary"
        }
      }, [_vm._v(" " + _vm._s(yundongyuan.name) + " " + _vm._s(yundongyuan.num) + "\n              ")])], 1)
    }), 1)], 1), _vm._v(" "), _c('el-row', {
      attrs: {
        "gutter": 20
      }
    }, [_c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "参赛运动员",
        "prop": "type"
      }
    }, _vm._l((subject.yundongyuan), function(yundongyuan, index) {
      return _c('div', [_vm._v("\n                运动员" + _vm._s(index + 1) + "\n                "), _c('el-tag', {
        key: index,
        staticStyle: {
          "margin-right": "10px"
        },
        attrs: {
          "type": "primary"
        }
      }, [_vm._v(" " + _vm._s(yundongyuan.name) + " " + _vm._s(yundongyuan.num) + "\n                ")])], 1)
    }), 0)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "替补运动员",
        "prop": "tbydy"
      }
    }, _vm._l((subject.tbydy), function(yundongyuan, index) {
      return _c('div', [_vm._v("\n                替补运动员" + _vm._s(index + 1) + "\n                "), _c('el-tag', {
        key: index,
        staticStyle: {
          "margin-right": "10px"
        },
        attrs: {
          "type": "primary"
        }
      }, [_vm._v(" " + _vm._s(yundongyuan.name) + " " + _vm._s(yundongyuan.num) + "\n                ")])], 1)
    }), 0)], 1)], 1), _vm._v(" "), _c('el-row', {
      attrs: {
        "gutter": 20
      }
    }, [_c('el-col', {
      attrs: {
        "span": 12
      }
    }, [(subject.sf_music_status == false && subject.music_url && subject.music_status == 2) ? _c('el-form-item', {
      attrs: {
        "label": "音乐试听",
        "prop": "name"
      }
    }, [_vm._v("已试听")]) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 12
      }
    }, [(subject.sf_music_status == false && subject.music_status == 3) ? _c('el-form-item', {
      attrs: {
        "label": "音乐试听",
        "prop": "name"
      }
    }, [_vm._v("现场提交并核对")]) : _vm._e()], 1)], 1)], 1)
  })], 2), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "footer-button"
  }, [_c('el-button', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'SaiDateList'
      }),
      expression: "{name:'SaiDateList'}"
    }],
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("返回首页\n        ")])], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c6228d0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/isai/SaiApplyFormSuccess.vue
// module id = 1374
// module chunks = 0